import React, { useState } from "react"
import { List, ListItemButton, ListItemIcon, ListItemText, IconButton, Divider, Box, Drawer, Stack, Typography, Collapse, Badge } from "@mui/material"

import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import DashboardIcon from "@mui/icons-material/Dashboard"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import SettingsIcon from "@mui/icons-material/Settings"

import MenuIcon from "@mui/icons-material/Menu"
import GavelIcon from "@mui/icons-material/Gavel"
import UploadFileIcon from "@mui/icons-material/UploadFile"
import BalanceIcon from "@mui/icons-material/Balance"
import { styled } from "@mui/material/styles"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import BusinessIcon from "@mui/icons-material/BusinessCenter"
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt"
import WorkspacesIcon from "@mui/icons-material/Workspaces"
import GroupsIcon from "@mui/icons-material/Groups"
import AssessmentIcon from "@mui/icons-material/Assessment"
import LogoWhite from "../assets/logo/logo-white.png"
import PaidIcon from "@mui/icons-material/Paid"
import LogoutIcon from "@mui/icons-material/Logout"
import AddBusinessIcon from "@mui/icons-material/AddBusiness"
import ContactPageIcon from "@mui/icons-material/ContactPage"
import ShowChartIcon from "@mui/icons-material/ShowChart"
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna"
// import RefundIcon from '../assets/icons/refund-icon.svg';
import { ReactComponent as RefundIcon } from "../assets/icons/refund-icon.svg"
import { ReactComponent as AppealIcon } from "../assets/icons/escalate_icon.svg"

import PPRFavicon from "../assets/icons/favicon.png"

import { useLocation } from "react-router-dom"

import "./protectedRouteSidebar.css"
import { useAuth } from "../context/AuthContext"
import AddIcon from "@mui/icons-material/Add"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import AddBoxIcon from "@mui/icons-material/AddBox"
import LocationCityIcon from "@mui/icons-material/Domain"
import AddLocationAltIcon from "@mui/icons-material/DomainAdd"
import DemoCTA from "./DemoCTA"

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(0, 1),
  height: "83px",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}))

const ListComponentInner = ({ open, list, parentList, level = 0, routePrefix, handleNavigate, setOpen, demoCtaOpener }) => {
  const [openGroups, setOpenGroups] = React.useState({})

  const toggleGroup = (id) => {
    demoCtaOpener()
  }

  const location = useLocation()
  const currentPath = location.pathname

  const handleLogout = () => {
    demoCtaOpener()
    // setAuthToken(null) // ✅ Clears both token and user in context + storage
    // window.location.href = "/"
  }

  return (
    <List className="protected-route-sidebar-list">
      {(list || []).map((_it, _it_index) => {
        if (_it.id === "logout")
          return (
            <ListItemButton
              onClick={handleLogout}
              sx={{
                pl: 2 + level * 2,
                flex: 1,
                height: "48px",
                "&:hover .hover-label": {
                  // display: open ? "none" : "block",
                  zIndex: 1000,
                  opacity: 1,
                  visibility: "visible",
                },
              }}
            >
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={"Logout"} />
              {!open && (
                <Box
                  sx={{
                    position: "fixed",
                    width: "100%",
                  }}
                >
                  <Typography
                    className="hover-label"
                    variant="body2"
                    sx={{
                      position: "absolute",
                      opacity: 0,
                      left: "50px",
                      top: "50%",
                      transform: "translate(-20px, -50%)",
                      whiteSpace: "nowrap",
                      backgroundColor: "var(--va-main-bg)",
                      color: "#fff",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      display: "block",
                      zIndex: 0,
                      visibility: "hidden",
                      transition: "all 0.4s ease",
                    }}
                  >
                    {"Logout"}
                  </Typography>
                </Box>
              )}
            </ListItemButton>
          )
        const ListItem = parentList.find((_l) => _l.id === _it.id)
        if (!ListItem) return null

        const hasChildren = ListItem.children?.length && _it.children?.length
        const isOpen = openGroups[ListItem.id]
        return (
          <React.Fragment key={ListItem.id}>
            <ListItemButton
              onClick={() => {
                if (hasChildren) {
                  toggleGroup(ListItem.id)
                } else if (ListItem.link) {
                  // console.log("routePrefix", routePrefix)
                  handleNavigate(routePrefix + ListItem.link)
                }
              }}
              sx={{
                pl: 2 + level * 2, // Adds left padding based on nesting level
                height: "48px",

                "&:hover .hover-label": {
                  // display: open ? "none" : "block",
                  zIndex: 1000,
                  opacity: 1,
                  visibility: "visible",
                },
              }}
              selected={currentPath === routePrefix + ListItem.link}
              className={`${currentPath === routePrefix + ListItem.link ? "active" : ""}`}
            >
              <div className="outer-div" style={{ display: "flex", width: "100%", flexDirection: "column" }}>
                <div className="outer-div-wrapper">
                  <div className="inner-upper-div"></div>
                  <div className="inner-div">
                    {currentPath === routePrefix + ListItem.link && (
                      <div
                        className="side-vertical-bar"
                        style={{
                          position: "absolute",
                          width: "5px",
                          height: "30px",
                          transform: "translateX(-10px)",
                          borderTopRightRadius: "7px",
                          borderBottomRightRadius: "7px",
                        }}
                      ></div>
                    )}
                    <RenderIcon ListItem={ListItem} />

                    {!open && (
                      <Box
                        sx={{
                          position: "fixed",
                          width: "100%",
                        }}
                      >
                        <Typography
                          className="hover-label"
                          variant="body2"
                          sx={{
                            position: "absolute",
                            opacity: 0,
                            top: "50%",
                            transform: "translate(-20px, -50%)",
                            whiteSpace: "nowrap",
                            backgroundColor: "var(--va-card-1)",
                            color: "var(--va-primary-color)",
                            fontFamily: "Figtree",
                            padding: "14px 12px 14px 0px",
                            border: "1px solid var(--va-primary-color)",
                            borderLeft: "0px dotted var(--va-primary-color)",
                            fontFamily: "Figtree",
                            borderRadius: "0px",
                            display: "block",
                            zIndex: 0,
                            visibility: "hidden",
                            transition: "all 0.4s ease",
                          }}
                        >
                          {ListItem.label}
                        </Typography>
                      </Box>
                    )}
                    {/* <ListItemText primary={ListItem.label} /> */}
                    {hasChildren ? (
                      <ListItemText
                        primary={
                          <Typography variant="subtitle2" fontFamily={"Figtree"}>
                            {ListItem.label}
                          </Typography>
                        }
                      />
                    ) : (
                      <Typography variant="subtitle2" fontFamily={"Figtree"}>
                        {ListItem.label}
                      </Typography>
                      // <ListItemText primary={ListItem.label} />
                    )}
                    {hasChildren && (
                      <ExpandMoreIcon
                        sx={{
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    )}
                  </div>
                  <div className="inner-lower-div"></div>
                </div>
              </div>
            </ListItemButton>
            {hasChildren && (
              <Collapse
                in={isOpen}
                timeout={{ enter: 400, exit: 300 }} // Customize duration
                unmountOnExit
                // sx={{
                //   transition: (theme) =>
                //     theme.transitions.create("all", {
                //       easing: theme.transitions.easing.easeInOut,
                //       duration: theme.transitions.duration.standard,
                //     }),
                // }}
              >
                {/* <Box sx={{ pl: 2 }}> */}
                <MemoizedListComponent list={_it.children} parentList={ListItem.children} level={level + 1} routePrefix={routePrefix} handleNavigate={handleNavigate} open={open} />
                {/* </Box> */}
              </Collapse>
            )}
          </React.Fragment>
        )
      })}

      {/* <ListItemButton
        sx={{
          pl: 2 + level * 2, // Adds left padding based on nesting level
          height: "48px",

          "&:hover .hover-label": {
            // display: open ? "none" : "block",
            zIndex: 1000,
            opacity: 1,
            visibility: "visible",
          },
        }}
      >
        <img src={PrepaidCardIconPng} width={"32px"} />
        <PrepaidCardIcon width={32} height={32} />
       
      </ListItemButton> */}
    </List>
  )
}

const MemoizedListComponent = React.memo(ListComponentInner)

const RenderIcon = ({ ListItem, active }) => {
  return ListItem.multipleIcon ? (
    <ListItemIcon>
      <IconButton
        sx={{
          position: "relative",
          fontSize: 30,
          padding: "0px",
          background: "transparent",
        }}
      >
        {/* Base icon */}
        <ListItem.ICON1 fontSize="inherit" color="inherit" />

        {/* Overlay icon */}
        <Box
          sx={{
            position: "absolute",
            top: -15,
            right: -2,
            pointerEvents: "none", // So overlay doesn't block clicks
          }}
        >
          <ListItem.ICON2 fontSize="small" />
        </Box>
      </IconButton>
    </ListItemIcon>
  ) : (
    <ListItemIcon className="sidebar-list-icon">{ListItem.ICONFUNCTION ? ListItem.ICONFUNCTION : <ListItem.ICON />}</ListItemIcon>
  )
}

export default function Sidebar({ onNavigate, setOpen, drawerWidth, open, routePrefix, list, list2 }) {
  const [showDemoCTA, setShowDemoCTA] = useState(false)

  const allList = [
    {
      id: "dash",
      label: "Dashboard",
      ICON: DashboardIcon,
      link: "/dashboard",
      isRoutePrefix: true,
    },

    {
      id: "create-user",
      label: "Create Profile",
      ICON: PersonAddAltIcon,
      link: "/create-user",
      isRoutePrefix: true,
    },

    {
      id: "client",
      label: "Organization",
      link: "/client",

      ICON: LocationCityIcon,
      isRoutePrefix: true,
    },

    {
      id: "add-new-client",
      label: "Add Client",
      link: "/add-new-client",
      ICON: AddLocationAltIcon,
      // ICON2: AddBoxIcon,

      // ICONFUNCTION: (
      //   <Stack direction="row" spacing={0.5} alignItems="center">
      //     <AccountBalanceIcon />
      //     <AddIcon />
      //   </Stack>
      // ),
      isRoutePrefix: true,
    },

    {
      id: "organizations",
      label: "Manage Clients",
      ICON: BusinessIcon,
      children: [
        {
          id: "view-organization",
          label: "View Clients",
          ICON: ContactPageIcon,
          link: "/clients",
          isRoutePrefix: true,
        },
        {
          id: "create-organization",
          label: "Add Client",
          ICON: AddBusinessIcon,
          link: "/add-new-client",
          isRoutePrefix: true,
        },
      ],
    },
    {
      id: "sales",
      label: "Sales",
      ICON: ShowChartIcon,
      link: "/sales",
      isRoutePrefix: true,
    },
    {
      id: "daily-sales-report",
      label: "Sales",
      ICON: AssessmentIcon,
      link: "/dsr",
      isRoutePrefix: true,
    },
    {
      id: "missing-rebate-detail",
      label: "Rebate Detail",
      ICON: RefundIcon,
      link: "/missing-rebate-detail",
      isRoutePrefix: true,
    },
    {
      id: "reconciliaion-detail",
      label: "Reconciliation Detail",
      ICON: BalanceIcon,
      link: "/reconciliaion-detail",
      isRoutePrefix: true,
    },
    {
      id: "appeals-detail",
      label: "Escalations",
      ICON: AppealIcon,
      link: "/appeals-detail",
      isRoutePrefix: true,
    },
    {
      id: "upload-appealed-file",
      label: "Upload Escalation File",
      ICON: AppealIcon,
      ICON1: UploadFileIcon,
      ICON2: GavelIcon,
      multipleIcon: true,
      link: "/upload-appealed-file",
      isRoutePrefix: true,
    },
    {
      id: "upload-employee-incentives",
      label: "Employee Incentives",
      ICON1: UploadFileIcon,
      ICON2: PaidIcon,
      multipleIcon: true,
      link: "/upload-employee-incentives",
      isRoutePrefix: true,
    },
    {
      id: "employees",
      label: "PPR Employees",
      ICON: GroupsIcon,
      link: "/employees",
      isRoutePrefix: true,
    },

    {
      id: "carrier-settings",
      label: "Carrier Settings",
      ICON: SettingsInputAntennaIcon,
      link: "/carrier-settings",
      isRoutePrefix: true,
    },

    {
      id: "profile",
      label: "Profile",
      ICON: AccountCircleIcon,
      link: "/profile",
      isRoutePrefix: true,
    },
    {
      id: "settings",
      label: "Settings",
      ICON: SettingsIcon,
      link: "/settings",
      isRoutePrefix: true,
    },

    {
      id: "client-selector",
      label: "Client Selector",
      ICON: WorkspacesIcon,
      link: "/client-selector",
      isRoutePrefix: true,
    },
    { id: "logout", label: "Logout", ICON: LogoutIcon },
  ]

  const openedMixin = (theme) => ({
    overflowX: "hidden",
    transition: "width 2s ease",
    width: drawerWidth,
    boxSizing: "border-box",
    // background:
    //   "linear-gradient(90deg, rgb(30 44 57), rgb(128 141 162)) !important",
    background: "var(--va-main-bg)",

    border: "0px",
    marginTop: "0px",
    borderTopRightRadius: "50px",

    // color: "rgb(210 210 210 / 87%)",
    // color: "var(--va-primary-color)",
  })
  // rgb(141 141 141 / 54%)
  const closedMixin = (theme) => ({
    overflowX: "hidden",
    transition: "width 2s ease",
    // width: `calc(${theme.spacing(7)} + 1px)`,
    width: `calc(${theme.spacing(8)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
    boxSizing: "border-box",
    // background:
    //   "linear-gradient(90deg, rgb(30 44 57), rgb(128 141 162)) !important",
    borderTopRightRadius: "40px",
    background: "var(--va-main-bg)",
    border: "0px",
    // color: "rgb(210 210 210 / 87%)",
  })

  const StyledDrawer = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: "240px",
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",

    "& .MuiDrawer-paper": {},

    ...(open ? { "& .MuiDrawer-paper": openedMixin(theme) } : { "& .MuiDrawer-paper": closedMixin(theme) }),
  }))

  const demoCtaOpener = () => {
    setShowDemoCTA(!showDemoCTA)
  }

  const handleToggleDrawer = () => {
    setOpen(!open)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const handleNavigate = (route) => {
    demoCtaOpener()
  }

  return (
    <>
      <DemoCTA open={showDemoCTA} onClose={() => setShowDemoCTA(false)} />

      {!open && (
        <>
          <img
            src={PPRFavicon}
            alt={"PPR"}
            width={"40px"}
            style={{
              position: "fixed",
              top: 5,
              left: 10,
              zIndex: 1300,
            }}
          />
          <IconButton
            className="sidebar-icon"
            onClick={handleToggleDrawer}
            color="inherit"
            sx={{
              position: "fixed",
              top: 45,
              left: 10,
              zIndex: 1300,
            }}
          >
            <MenuIcon />
          </IconButton>
        </>
      )}

      <StyledDrawer variant="permanent" open={open} onClose={handleToggleDrawer}>
        <Box
          role="presentation"
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ background: "var(--va-card-1)" }}>
            {open ? (
              <DrawerHeader sx={{ background: "var(--va-main-bg)" }}>
                <div style={{ flex: "1", marginLeft: "10px" }}>
                  <img src={LogoWhite} width={"120px"} alt="Prepaid Recon" />
                </div>
                <IconButton onClick={handleDrawerClose} className="sidebar-icon">
                  <ChevronLeftIcon />
                </IconButton>
              </DrawerHeader>
            ) : (
              <div style={{ height: "83px", background: "var(--va-main-bg)" }}></div>
            )}

            <Divider sx={{ background: "var(--va-card-4)" }} />

            <MemoizedListComponent
              open={open}
              list={list} // Don't include logout
              parentList={allList}
              level={0}
              routePrefix={routePrefix}
              handleNavigate={handleNavigate}
              setOpen={setOpen}
              demoCtaOpener={demoCtaOpener}
            />
          </Box>

          <Box sx={{ mb: 2, background: "var(--va-card-1)" }}>
            <Divider sx={{ background: "var(--va-card-4)" }} />

            <MemoizedListComponent
              open={open}
              list={[...list2, { id: "logout" }]} // Only logout here
              parentList={allList}
              level={0}
              routePrefix={routePrefix}
              handleNavigate={handleNavigate}
              demoCtaOpener={demoCtaOpener}
            />
            {/* <ListComponentInner
              open={open}
              list={[{ id: "logout" }]} // Only logout here
              parentList={[{ id: "logout", label: "Logout", ICON: LogoutIcon }]}
              level={0}
              routePrefix={routePrefix}
              handleNavigate={handleNavigate}
            /> */}
          </Box>
        </Box>
      </StyledDrawer>
    </>
  )
}
